import { makeStyles } from "@mui/styles";
import axios from "axios";

const verifyQRCode = async (_id, security_code, token) => {
  try {
    const { status } = await axios.post(
      "/api/v1/2FA/verify-secret",
      {
        user_secret: security_code,
        user_id: _id,
      },
      {
        headers: {
          Authorization: token,
        },
      },
    );
    if (status === 200) return { status: 200, error: null };
  } catch (catchError) {
    const catchErrorMsg =
      catchError &&
      catchError.response &&
      catchError.response.data &&
      catchError.response.data.error &&
      catchError.response.data.error.msg;
    return { status: 500, error: catchErrorMsg };
  }
};

const verifySMSCode = async (_id, sms_code, token) => {
  try {
    const { status } = await axios.post(
      "/api/v1/2FA/verify-sms",
      {
        sms_code,
        user_id: _id,
      },
      {
        headers: {
          Authorization: token,
        },
      },
    );
    if (status === 200) {
      return { status: 200, error: null };
    }
  } catch (catchError) {
    const catchErrorMsg =
      catchError &&
      catchError.response &&
      catchError.response.data &&
      catchError.response.data.error &&
      catchError.response.data.error.msg;
    return { status: 400, error: catchErrorMsg };
  }
};

const sendSMSCode = async (user_id, phone_number) => {
  try {
    await axios.post(`/api/v1/2FA/send-sms`, {
      user_id,
      phone_number,
    });

    return { status: 200, error: null };
  } catch (error) {
    const errorMessage =
      error &&
      error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.msg;

    return { status: 400, error: errorMessage };
  }
};

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "5%",
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "white",
    color: theme.palette.primary.main,
    width: theme.spacing(12),
    fontSize: "20px",
    height: theme.spacing(12),
    border: `2px solid ${theme.palette.primary.main}`,
    "& .MuiSvgIcon-root": {
      fontSize: "45px",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: "3% 0",
    color: theme.palette.white.main,
  },

  paragraph: {
    fontSize: "13px",
    color: theme.palette.secondary.main,
  },
  textMsgLink: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export { verifyQRCode, verifySMSCode, sendSMSCode, useStyles };
